// A turtle + sound-wave glyph for the "slow speed" speak button - echoes
// FontAwesome's faVolumeHigh (source + concentric sound arcs) grammar, but
// swaps the speaker cone for かめ's turtle, so it reads as "slow audio"
// rather than an unrelated silhouette. Built from simple primitives (not one
// hand-tuned path) so its proportions stay easy to reason about/adjust.
function SlowTurtleIcon({ className }: { className?: string }) {
    return (
        <svg viewBox="-0.5 5 22 15" width="2em" height="1.36em" className={className} aria-hidden="true" focusable="false">
            {/* tail */}
            <path fill="currentColor" d="M1.6 14.6 0 13.6l.4 2.4z" />
            {/* back-left leg */}
            <ellipse fill="currentColor" cx="2.6" cy="10.1" rx="1.5" ry="1.1" transform="rotate(-50 2.6 10.1)" />
            {/* front-left leg */}
            <ellipse fill="currentColor" cx="3.4" cy="17.3" rx="1.7" ry="1.2" transform="rotate(-30 3.4 17.3)" />
            {/* front-right leg, near the head */}
            <ellipse fill="currentColor" cx="11.2" cy="17.7" rx="1.7" ry="1.2" transform="rotate(25 11.2 17.7)" />
            {/* shell */}
            <ellipse fill="currentColor" cx="7.5" cy="13.4" rx="6" ry="4.7" />
            {/* neck, bridging the shell to the head */}
            <path fill="currentColor" d="M12 11.3q2.3-2.3 3.6-1.2-.6 2.4-3.7 3.1z" />
            {/* head */}
            <circle fill="currentColor" cx="14.7" cy="10.6" r="2.3" />
            {/* slow, quiet sound waves */}
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                d="M17.2 8.8q2.3 1.8 0 3.6"
            />
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                d="M19.1 7q3.9 3.4 0 6.8"
            />
        </svg>
    );
}

export default SlowTurtleIcon;
